import axios from 'axios';
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {fetchProfileData} from "../../../../entities/Profile/model/fetchProfileDate/fetchProfileDate";



export const deleteAvatar = createAsyncThunk<void>(
    'user/deleteAvatar',
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const { token } = JSON.parse(authToken);
            const response = await axios.delete('/api/profile/avatar', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status === 200) {
                await thunkAPI.dispatch(fetchProfileData());
            } else {
                throw new Error('Failed to delete avatar');
            }
        } catch (error) {
            console.error(error);
            throw error; // Пробрасываем ошибку дальше, чтобы ее можно было обработать в компоненте
        }
    }
);